import { render, staticRenderFns } from "./activitiesDetail2021zz.vue?vue&type=template&id=6b50b24b&scoped=true"
import script from "./activitiesDetail2021zz.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021zz.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021zz.vue?vue&type=style&index=0&id=6b50b24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50b24b",
  null
  
)

export default component.exports